import PropTypes from 'prop-types';
import React from 'react';
import style from './style.module.scss';

const TableHeader = ({ children, className }) => (
  <thead className={`${style.head} ${className}`}>{children}</thead>
);

TableHeader.defaultProps = {
  className: '',
};

TableHeader.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default TableHeader;
